import PointSale from '@/components/point-of-sale/point-of-sale'

export default [{
  path: 'point-of-sale',
  name: 'point',
  component: PointSale,
  meta: {
    breadcrumb: 'Búsqueda',
    title: 'Puntos de venta',
    colorHeader: '#E64858',
    top: 0,
    position: 'fixed',
    height: 30
  }
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/point-of-sale/point-of-sale.js